import type { SpriNavigationItem } from '@spri/components/navigation';

import { patientsBasicNavigationItem, positConnectBasicNavigationItem } from './navigation-shared-basic-items';

export const administratorNavigation: SpriNavigationItem[] = [
  {
    id: 'schedule',
    title: 'Schedule',
    type: 'basic',
    icon: 'calendar',
    link: '/schedule',
  },
  {
    id: 'reception',
    title: 'Reception',
    type: 'basic',
    icon: 'reception',
    link: '/reception',
  },
  // Clinical Data
  {
    id: 'clinical-data',
    title: 'Clinical Data',
    type: 'collapsable',
    icon: 'clinical-data',
    children: [
      {
        id: 'surgery-forms',
        title: 'Surgery Forms',
        type: 'basic',
        link: '/clinical-data/surgery-form',
      },
      {
        id: 'exam-forms',
        title: 'Exam Forms',
        type: 'basic',
        link: '/clinical-data/exam-form',
      },
    ],
  },
  // Patient Surveys
  {
    id: 'patient-surveys',
    title: 'Patient Surveys',
    type: 'collapsable',
    icon: 'patient-survey',
    children: [
      {
        id: 'manual',
        title: 'Manual',
        type: 'basic',
        link: '/patient-surveys/manual',
      },
      {
        id: 'automated',
        title: 'Automated',
        type: 'basic',
        link: '/patient-surveys/automated-surveys',
      },
    ],
  },
  patientsBasicNavigationItem,
  positConnectBasicNavigationItem,
  {
    id: 'administrative',
    title: 'Administrative',
    type: 'collapsable',
    icon: 'settings',
    children: [
      {
        id: 'admin-analytics',
        title: 'Analytics',
        type: 'basic',
        link: '/administrative/analytics',
      },
      {
        id: 'admin-users',
        title: 'Users',
        type: 'basic',
        link: '/administrative/users',
      },
      {
        id: 'admin-clinicians',
        title: 'Clinicians',
        type: 'basic',
        link: '/administrative/clinicians',
      },
      {
        id: 'correspondence',
        title: 'Correspondence',
        type: 'basic',
        link: '/administrative/correspondence',
      },
      {
        id: 'form-builder',
        title: 'Form Builder',
        type: 'basic',
        link: 'https://studio.formsort.com/auth/login',
        externalLink: true,
      },
      {
        id: 'survey-builder',
        title: 'Survey Builder',
        type: 'basic',
        link: 'https://fs1.formsite.com/form_app/FormSite?FormId=LoadLogin&Auto',
        externalLink: true,
      },
    ],
  },
];

// Export the same navigation for different layout types
export const compactNavigation = administratorNavigation;
export const futuristicNavigation = administratorNavigation;
export const horizontalNavigation = administratorNavigation;
